export const testImageUrlAsync = url => {

    const imgPromise = new Promise(function imgPromise(resolve, reject) {

        const imgElement = new Image()

        imgElement.addEventListener('load', function imgOnLoad() {
            resolve(this)
        })

        imgElement.addEventListener('error', function imgOnError() {
            reject()
        })

        imgElement.src = url

    })

    return imgPromise
}

export const testImageUrl = url => {
    const tester = new Image()
    tester.onload = imageFound
    tester.onerror = imageNotFound
    tester.src = url

    return tester
}

const imageFound = () => {
    return true
}

const imageNotFound = () => {
    return false
}